import { render } from "./Text.vue?vue&type=template&id=e3058d1a"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=e3058d1a&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__